import(/* webpackMode: "eager" */ "/vercel/path0/src/app/sugerencias/page.tsx");
